import { Injectable } from '@angular/core';
import {ApiRequestService, HttpRequestType} from '../OffService/api-request.service';
import {RequestHandler} from '../OffService/request-handler';
import {SyncService} from '../OffService/sync.service';
import { ProductosModel } from 'src/app/models/productos/productos.model';

@Injectable({
    providedIn: 'root'
})
export class OtrasDenominacionesApiService {

    public otrasDenominacionesGET = new RequestHandler<ProductosModel>();

    constructor(private syncService: SyncService<ProductosModel>,
        private api: ApiRequestService<ProductosModel>) {

        this.defineOtrasDenominacionesGET();
    }

    public defineOtrasDenominacionesGET() {
        this.otrasDenominacionesGET
            .fetch(HttpRequestType.GET, 'mg/otrasdenominaciones');

        this.api
            .registerRequest(this.otrasDenominacionesGET);

        this.syncService
            .register(this.syncService.baseSyncPolicy(this.otrasDenominacionesGET));
    }
}
